/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./SelectOffice.module.css";

interface OfficeItemProps {
  name: string;
  code: string;
  details?: string;
  checked: boolean;
}

const OfficeItem: React.FC<OfficeItemProps> = ({
  name,
  code,
  details,
  checked,
}) => {
  return (
    <div className={styles.officeItem}>
      <div className={styles.checkbox}>
        {checked ? "check_box" : "check_box_outline_blank"}
      </div>
      <div className={styles.officeDetails}>
        {name} / {code} {details && `/ ${details}`}
      </div>
    </div>
  );
};

const OfficeList: React.FC = () => {
  const offices: OfficeItemProps[] = [
    { name: "Main Office", code: "012-1234-7", checked: true },
    {
      name: "ABC Office",
      code: "375-5418-9",
      details: "Dolor Lorem Ipsum",
      checked: false,
    },
    {
      name: "JQW Office",
      code: "454-7236-15",
      details: "TBC WL Fst",
      checked: false,
    },
  ];

  return (
    <section>
      <header className={styles.officeHeader}>
        <h3 className={styles.officeHeaderText}>Office</h3>
      </header>
      {offices.map((office, index) => (
        <OfficeItem key={index} {...office} />
      ))}
    </section>
  );
};

export default OfficeList;
